import {Component, Input} from '@angular/core';
import {CreateUpdateComponent} from "../create-update.component";

@Component({
    selector: 'app-create-update-form',
    templateUrl: './app-create-update-form.component.html',
    standalone: false
})
export class AppCreateUpdateFormComponent {
  @Input() base: CreateUpdateComponent<any>;

  focusFirstError($event) {
    this.base.form.updateValueAndValidity();
    this.base.form.markAllAsTouched();

    const form = $event.target.closest('form');
    const invalidControl = form.querySelector('.ng-invalid') || form.querySelector('.invalid-feedback');

    if (invalidControl) {
      invalidControl.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }

}
